import { render, staticRenderFns } from "./UcSiteSelector.yaml?vue&type=template&id=5521e92e&component"
import script from "./UcSiteSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcSiteSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports